import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { industries } from '../../data/industries';
type IndustriesHeroProps = {
  onExplore: () => void;
};
export function IndustriesHero({
  onExplore
}: IndustriesHeroProps) {
  const [index, setIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (reduceMotion) return;
    const timer = window.setInterval(() => setIndex(i => (i + 1) % industries.length), 2200);
    return () => window.clearInterval(timer);
  }, [reduceMotion]);
  return <section className="relative overflow-hidden bg-brand-black px-4 pb-24 pt-20 sm:px-6 lg:px-8 lg:pb-32 lg:pt-28" data-id="element-505" data-mp="plt7fthyuzn5">
      <div className="mx-auto max-w-7xl" data-id="element-506" data-mp="uitdi4etg2e9">
        <p className="text-sm font-semibold text-brand-light" data-id="element-507" data-mp="2rc4pzhxgwym6">Industries we serve</p>
        <h1 className="mt-6 text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-8xl" data-id="element-508" data-mp="2wazhd89i3vhw">
          Marketing built for
          <span className="relative block h-[1.1em] overflow-hidden text-brand-red" aria-live="polite" data-id="element-509" data-mp="3mwd0cdpz4ge">
            <AnimatePresence mode="popLayout" initial={false} data-id="element-510" data-mp="3uz7jb33ca5r2">
              <motion.span key={industries[index].id} initial={{
              y: '100%',
              opacity: 0
            }} animate={{
              y: '0%',
              opacity: 1
            }} exit={{
              y: '-100%',
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: [0.23, 1, 0.32, 1]
            }} className="absolute left-0 top-0 whitespace-nowrap" data-id="element-511" data-mp="3qynmk0moh45g">
                {industries[index].name}.
              </motion.span>
            </AnimatePresence>
          </span>
        </h1>

        <div className="mt-12 flex flex-col gap-8 border-t border-white/15 pt-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-512" data-mp="8lz5yygfdk80">
          <p className="max-w-xl text-lg leading-relaxed text-brand-light" data-id="element-513" data-mp="2yc2u0wugum0b">
            Every industry has its own way of winning customers. We build the website, marketing and automations around
            how <em className="not-italic text-white" data-id="element-514" data-mp="2ut3pue1xh9p2">your</em> business actually runs.
          </p>
          <button type="button" onClick={onExplore} className="group inline-flex items-center gap-2 self-start rounded-md bg-brand-red px-7 py-4 text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black lg:self-auto" data-id="element-515" data-mp="2zr59b039nb12">
            Find your industry
            <ArrowDownIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-y-0.5" aria-hidden="true" data-id="element-516" data-mp="231xxwkwd2iav" />
          </button>
        </div>
      </div>
    </section>;
}